import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import store from '@/store/store';

import Main from '@/modules/main/main.vue';
import Login from '@/modules/login/login.vue';
// import Register from '@/modules/register/register.vue.old';
import Dashboard from '@/pages/dashboard/dashboard.vue';
import Profile from '@/pages/profile/profile.vue';
import Blank from '@/pages/blank/blank.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/chat',
        name: 'chat',
        component: () => import('@/pages/chat/chat.vue'),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('@/pages/test.vue'),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'blank',
        name: 'Blank',
        component: Blank,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/pages/users/users.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'user-detail/:id?',
        name: 'user-detail',
        component: () => import('@/pages/users/user-detail.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'customers',
        name: 'Customers',
        component: () => import('@/pages/customers/customers.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'customer-detail/:id?',
        name: 'customer-detail',
        component: () => import('@/pages/customers/customer-detail.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'customers-devices',
        name: 'CustomersDevices',
        component: () =>
          import('@/pages/customers-devices/customers-devices.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'customers-device-detail/:id?',
        name: 'customers-device-detail',
        component: () => import('@/pages/customers-devices/customers-device-detail.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'customers-devices-logs',
        name: 'CustomersDevicesLogs',
        component: () =>
            import('@/pages/customers-devices-logs/customers-devices-logs.vue'),
        meta: {
          requiresAuth: true
        }
      },
      // {
      //     path: 'sub-menu-1',
      //     name: 'Sub Menu 1',
      //     component: SubMenu,
      //     meta: {
      //         requiresAuth: true
      //     }
      // },
      // {
      //     path: 'sub-menu-2',
      //     name: 'Sub Menu 2',
      //     component: Blank,
      //     meta: {
      //         requiresAuth: true
      //     }
      // },
      {
        path: '',
        name: 'Dashboard',
        component: () =>
            import('@/pages/customers-devices-logs/customers-devices-logs.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresUnauth: true
    }
  }
  // {
  //     path: '/register',
  //     name: 'Register',
  //     component: Register,
  //     meta: {
  //         requiresUnauth: true
  //     }
  // },
  // {
  //     path: '/forgot-password',
  //     name: 'ForgotPassword',
  //     component: ForgotPassword,
  //     meta: {
  //         requiresUnauth: true
  //     }
  // },
  // {
  //     path: '/recover-password',
  //     name: 'RecoverPassword',
  //     component: RecoverPassword,
  //     meta: {
  //         requiresUnauth: true
  //     }
  // },
  // {
  //     path: '/privacy-policy',
  //     name: 'RecoverPassword',
  //     component: PrivacyPolicy
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters['auth/token']) {
    next('/login');
  } else if (to.meta.requiresUnauth && !!store.getters['auth/token']) {
    next('/');
  } else {
    next();
  }
});

export default router;
